import { useQuery } from '@tanstack/react-query';
import { Employee } from '../../../types/Employee';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export const fetchEmployee = async (uuid: string) => {
  const response = await CustomAxios.get<Employee>(`employees/${uuid}`);
  const { data } = response;
  return data;
};

interface UseGetEmployeeByIdProps {
  uuid: string;
  enabled?: boolean;
}
export function useGetEmployeeById({ uuid, enabled = true }: UseGetEmployeeByIdProps) {
  const query = useQuery({
    enabled: enabled,
    queryKey: [queryKeys.allEmployees, uuid],
    queryFn: () => fetchEmployee(uuid),
  });

  return query;
}
